import { ApplicationCost } from '@amzn/awscat-portfolio-assessment-types';
import { Link } from '@amzn/awsui-components-react';

import { constants } from '../../../common/Localization';
import { formatCurrencyNoDecimals, formatPercentage, formatPercentageAsString } from '../../../common/LocalizationHelper';
import { ColumnDefinition, ColumnTypes } from '../../../common/table/types';
import { compare, roundToInteger } from '../../../common/util';
import { getCell } from '../../common/awsui-table-helper';

export const ApplicationCostColumnDefinition = (currency: string, selectApplication: (applicationId: string) => void):
    ColumnDefinition<ApplicationCost>[] => {
    return [
        {
            cell: item => (<Link onFollow={() => selectApplication(item.applicationId)}>{item.applicationId}</Link>),
            header: constants.APPLICATION_ID,
            id: 'applicationId',
            sortingField: 'applicationId',
            type: ColumnTypes.TEXT,
        },
        {
            data: item => roundToInteger(item.aws.totalCost),
            cell: item => getCell(formatCurrencyNoDecimals(item.aws.totalCost, currency)),
            header: constants.AWS_COST,
            id: 'awsCost',
            sortingComparator: (a: ApplicationCost, b: ApplicationCost) => {
                const firstField = a.aws.totalCost;
                const secondField = b.aws.totalCost;
                return compare(firstField, secondField);
            },
            type: ColumnTypes.NUMBER,
        },
        {
            data: item => roundToInteger(item.onPremises.totalCost),
            cell: item => getCell(formatCurrencyNoDecimals(item.onPremises.totalCost, currency)),
            header: constants.ON_PREMISES_COST,
            id: 'onPremisesCost',
            sortingComparator: (a: ApplicationCost, b: ApplicationCost) => {
                const firstField = a.onPremises.totalCost;
                const secondField = b.onPremises.totalCost;
                return compare(firstField, secondField);
            },
            type: ColumnTypes.NUMBER,
        },
        {
            data: item => formatPercentageAsString(item.onPremises.totalCost ? 1 - (item.aws.totalCost / item.onPremises.totalCost) : 0),
            cell: item => getCell(formatPercentage(item.onPremises.totalCost ? 1 - (item.aws.totalCost / item.onPremises.totalCost) : 0)),
            header: constants.SAVINGS,
            id: 'savings',
            sortingComparator: (a: ApplicationCost, b: ApplicationCost) => {
                const firstField = 1 - (a.aws.totalCost / a.onPremises.totalCost);
                const secondField = 1 - (b.aws.totalCost / b.onPremises.totalCost);
                return compare(firstField, secondField);
            },
            type: ColumnTypes.NUMBER,
        },
    ];
};
